export default __webpack_public_path__ + "static/media/image_2.53d14406.webp";